import React from 'react';

type PaymentStepProps = {
	children?: React.ReactNode;
};

const PaymentStep = ({ children }: PaymentStepProps) => {
	const style = {

		animation: 'fadeInFromRight 0.45s',
		animationFillDirection: 'forwards',
		marginBottom: '2em'
	};

	return (
		<div style={style}>
			{children}
		</div>
	);
};

export default PaymentStep;
